import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { FeatureResponse } from "api/feature/type";
import { NoInfer } from "react-redux";
import { FeatureStateType } from "types/feature";

import { getFeature } from "./feature.thunk";

export const extraReducers = (
  builder: ActionReducerMapBuilder<NoInfer<FeatureStateType>>
) => {
  builder
    .addCase(getFeature.pending, (state: FeatureStateType) => {
      state.isLoading = true;
    })
    .addCase(
      getFeature.fulfilled,
      (state: FeatureStateType, action: PayloadAction<FeatureResponse>) => {
        state.isLoading = false;
        state.toggle = action?.payload?.data?.toggle;
      }
    );
};
